import { createSelector } from 'reselect';
import { fastShippingCopySignedInSelector } from 'selectors/testTarget/offers/fastShippingCopySignedIn/fastShippingCopySignedInSelector';

const showSelector = createSelector(fastShippingCopySignedInSelector, fastShippingCopySignedIn => !!fastShippingCopySignedIn.show);

export { showSelector };
